import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRowingNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="sports_rowing_normal_large_svg__a">
        <path d="M0 0h48v48H0z" />
      </clipPath>
      <g clipPath="url(#sports_rowing_normal_large_svg__a)" fill="">
        <path d="M11.95 48.04L19.41 34h2.2l1.07-2h-2.2l2.39-4.5-1.13-2.14L18.21 32h-2.19l-1.06 2h2.19L9.68 48.04zm13.19-29.08l1.14 2.13 3.45-6.49c.083-.002.167-.009.25-.02A10.065 10.065 0 0038 9.18L42.68 0h-9.23l-3.73 7.12a13.887 13.887 0 00-1.58 5.91 2.026 2.026 0 00-.01.25.05.05 0 00-.01.03c0 .01.003.021.01.03l-2.99 5.61zm6.35-10.91L34.66 2h4.76l-3.2 6.27a7.931 7.931 0 01-6.05 4.29c.14-1.575.59-3.107 1.32-4.51z" />
        <path d="M10 9.18a10.065 10.065 0 008.27 5.42l4.58 8.61.02.03v.01L24 25.37v.01L27.52 32h-2.2l1.07 2h2.2l7.46 14.04h2.27L30.85 34h2.19l-1.06-2h-2.19l-5.8-10.91v-.01l-4.12-7.74a.05.05 0 000-.06 1.987 1.987 0 00-.01-.25 13.886 13.886 0 00-1.58-5.91L14.55 0H5.32zm6.51-1.13a12.305 12.305 0 011.33 4.51 7.932 7.932 0 01-6.06-4.29L8.58 2h4.76z" />
      </g>
    </svg>
  )
);
SvgSportsRowingNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsRowingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRowingNormalLarge;
